import Enum from "../Enum";

export default Enum.create( {
	USER_PROFILE: "USER_PROFILE",
	USER_PROFILE_LOAD_ERROR: "USER_PROFILE_LOAD_ERROR",
} );
